import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

/**
 * Theme-aware recharts tooltip used by all charts in the dashboard.
 */
const CustomTooltip = ({ active, payload, label }) => {
    const theme = useTheme();
    if (!active || !payload?.length) return null;

    return (
        <Box
            sx={{
                background: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 2,
                p: 1.5,
                boxShadow: theme.shadows[4],
            }}
        >
            <Typography
                variant="caption"
                sx={{ fontWeight: 700, color: 'text.primary', display: 'block', mb: 0.5 }}
            >
                {label}
            </Typography>

            {payload.map((entry) => (
                <Typography
                    key={entry.name}
                    variant="caption"
                    sx={{ color: entry.color, display: 'block' }}
                >
                    {entry.name}:{' '}
                    <strong>
                        {typeof entry.value === 'number'
                            ? entry.value.toLocaleString()
                            : entry.value}
                    </strong>
                </Typography>
            ))}
        </Box>
    );
};

export default CustomTooltip;
